import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule, ModalController} from '@ionic/angular';


@Component({
  standalone: true,
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  imports: [
    IonicModule,
    CommonModule
]
})
export class ErrorDialogComponent {

  @Input() errorInfo: any;

  constructor(
    private modalCtrl: ModalController
  ) {
  }

  async close() {
    await this.modalCtrl.dismiss(null, 'cancel');
  }

  async confirm() {
    await this.modalCtrl.dismiss(null, 'cancel');
  }
}
